import { atom } from 'jotai';
import type { NodesBaseConfig } from '@src/scenario-editor/render-utils/types';

export const nodesConfigAtom = atom<NodesBaseConfig[]>([]);
